import { useCallback } from 'react';
import { useIntegrationsApi } from '../api';
import { GetIntegrationsParams } from '../types';

export const useIntegrationsService = () => {
  const api = useIntegrationsApi();

  const getIntegrations = useCallback(async (params: GetIntegrationsParams) => {
    const response = await api.getIntegrations(params);
    return response.data;
  }, []);

  const getHookEventTypes = useCallback(async () => {
    const response = await api.getHookEventTypes();
    return response.data;
  }, []);

  return {
    getIntegrations,
    getHookEventTypes,
  };
};
